import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AzureAccessGuard implements CanActivate {
  constructor() {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (typeof window === 'undefined') return true;

    if (!environment.useCampaignPasswordProtection) {
      return true;
    }

    // Allow forcing a reset by adding ?clear=1 to the URL
    if (route.queryParamMap.has('clear')) {
      localStorage.removeItem('azure_access_granted');
    }

    const hostname = window.location.hostname.toLowerCase();
    
    // Apply protection on Azure OR localhost (for testing)
    if (!hostname.endsWith('azurewebsites.net') || hostname.includes('localhost')) {
      return true;
    }

    const isAuthorized = localStorage.getItem('azure_access_granted') === 'true';
    if (isAuthorized) {
      return true;
    }

    const userInput = prompt('This is a restricted campaign environment. Please enter the password:');
    if (userInput === environment.campaignPassword) {
      localStorage.setItem('azure_access_granted', 'true');
      return true;
    }

    alert('Unauthorized access.');
    return false;
  }
}
